import { Link } from '../lib/router';
import { useI18n } from '../i18n';
import { LangSwitcher } from './LangSwitcher';

/** En-tête de page intérieure : retour portail + titre + langue. */
export function PageHeader({ title, backTo = '/' }: { title?: string; backTo?: string }) {
  const { t } = useI18n();
  return (
    <header className="mb-pageheader">
      <Link to={backTo} className="mb-pageheader-back" aria-label={t('back')}>
        <span aria-hidden="true">←</span> {t('back')}
      </Link>
      {title && <span className="mb-pageheader-title">{title}</span>}
      <LangSwitcher />
    </header>
  );
}
